import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'fury-toolbar-quickpanel-toggle',
    templateUrl: './toolbar-quickpanel-toggle.component.html',
    styleUrls: ['./toolbar-quickpanel-toggle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToolbarQuickpanelToggleComponent {

  @Output() openQuickPanel = new EventEmitter();

  constructor() {
  }
}
